module.exports = __webpack_public_path__ + "static/media/recipe_top_banner_zh.cbb0bd2d.png";